import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-semantic",
  "use": "icon-leo-semantic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-semantic\">\r\n<g transform=\"translate(-176.128 -219.136) scale(1.344000)\">\r\n<path d=\"M192 288h448v192l-96 64v192H288V544l-96-64V288zm96 64v96h256v-96H288z\" />\r\n  <path d=\"M704 416h128v384H704V416zm48 64v256h32V480h-32z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-semantic.svg
// module id = JCxe
// module chunks = 546